import React from "react";
import GameInstructionModal from "../GameInstructionModal";

const BlueRedSmoothMovementModal = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Smooth Movement (Red/Blue)"
      gamePath="/userDashboard/game/red-and-blue-smoothMovement"
      icon="solar:round-transfer-horizontal-bold"
      instructions={[
        "Wear red and blue glasses.",
        "Track the moving letter on the screen and press the corresponding key on your keyboard."
      ]}
      isBinocular={true}
    />
  );
};

export default BlueRedSmoothMovementModal;
